import { AppBar, Toolbar } from '@mui/material';
import { ServiceDeskLink } from 'shared/components';
import { ClientLogo } from 'shared/logos';

export function HeaderPublic() {
    return (
        <AppBar position='static'>
            <Toolbar
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <ClientLogo />
                <ServiceDeskLink />
            </Toolbar>
        </AppBar>
    );
}
